<template>
	<div class="tablediv">
		<el-skeleton :rows="20" :loading="loadingMask" animated :throttle="500">
			<el-table id="filterTable" ref="filterTable" :data="resultDataList" style="width: 100%" max-height="800">
				<el-table-column v-for="(item,index) in resultHeadList" 
					:prop="item.prop" 
					:label="item.label"
					:sortable="item.sortable" 
					:filters="item.filters?item.filters:''" 
					:filtered-value="item.filters?item.filteredvalue:''"
					:filter-method="item.filters?filterHandler:''">
				</el-table-column>
			</el-table>
		</el-skeleton>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableid:'',
				tablename:'',
				loadingMask: true,
				resultDataList: [],
				resultDataShowList: [],
				resultHeadList: [],
			}
		},
		props: [
			'colid',
			// 'colname',
		],
		components: {},
		watch: {
			colid() {
				this.searchfnc();
			}
		},
		created: function() {

		},
		mounted: function() {
			this.searchfnc();
		},
		methods: {
			searchfnc: function() {
				if (this.colid) {
					this.tableid=this.colid.split('_')[0];
					this.tablename=this.colid.split('_')[1];
					let _this = this;
					_this.loadingMask = true;
					_this.resultDataList = [];
					_this.resultHeadList = [];
					this.$http({
							method: 'get',
							url: 'szjjchart/selectchartunstructureBytagID',
							responseType: 'json',
							params: {
								tagID: this.tableid
							},
						})
						.then(function(response) {
							_this.resultDataList = JSON.parse(response.data.data.data.information);
							if (_this.resultDataList.length > 0) {
								for (var i = 0; i < _this.resultDataList.length; i++) {
									if (_this.resultDataList[i]['排名']) {
										_this.resultDataList[i]['排名'] = parseInt(_this.resultDataList[i]['排名']);
									}
								}
								var tempkeys = Object.keys(_this.resultDataList[0]);
								var tempyearcheck = [];
								var tempyearselect=0;
								for (var i = 0; i < tempkeys.length; i++) {
									_this.resultHeadList.push({
										prop: tempkeys[i],
										label: tempkeys[i],
									})
									if (tempkeys[i].indexOf('排名') > -1) {
										_this.resultHeadList[i].sortable = true;
									}
									if (tempkeys[i] == '年份') {
										_this.resultHeadList[i].filters = [];
										for (var j = 0; j < _this.resultDataList.length; j++) {
											if (tempyearcheck.indexOf(_this.resultDataList[j]['年份']) < 0) {
												tempyearcheck.push(_this.resultDataList[j]['年份']);
												_this.resultHeadList[i].filters.push({
													text: _this.resultDataList[j]['年份'],
													value: _this.resultDataList[j]['年份']
												})
												if(_this.resultHeadList[i].filters.length<2){
													tempyearselect=i;
													_this.resultHeadList[i].filteredvalue=[_this.resultDataList[j]['年份']];
													_this.$nextTick(function(){
														const tableref=_this.$refs.filterTable;
														var column=tableref.columns[tempyearselect];
														tableref.store.commit('filterChange', {	
															column,
															values: column.filteredValue,
															silent: true
														})
													})
												}
											}
										}
									}
								}
							}
							_this.resultDataShowList=_this.resultDataList;
							_this.loadingMask = false;
						})
						.catch(function(error) {
							_this.loadingMask = false;
							console.log(error);
						});
				}
			},
			filterHandler(value, row, column) {
				const property = column['property'];
				return row[property] === value;
			}
		}
	}
</script>

<style>
</style>
